import {NgModule} from '@angular/core';
import {TransformNumberDirective} from './transform-number.directive';
import {TransformDateDirective} from './transform-date.directive';
import {MomentDatePipe} from './moment-date.pipe';
import {DecimalPipe} from '@angular/common';
import {TrimDirective} from './trim.directive';

@NgModule({
    declarations: [
        TransformDateDirective,
        MomentDatePipe,
        TransformNumberDirective,
        TrimDirective
    ],
    exports: [
        TransformDateDirective,
        MomentDatePipe,
        TransformNumberDirective,
        TrimDirective
    ],
    providers: [
        DecimalPipe
    ]
})
export class TransformationModule {
}
